// ONE central place for the free-design offer + pricing copy.
// Change here → changes everywhere (homepage, pricing, register, paywall, exit intent, how-it-works).
export const OFFER = {
  FREE_DESIGNS_ON_SIGNUP: 1,
  REFERRAL_BONUS_DESIGNS: 1,
  PRICE: "$4.99/mo",
  PRICE_LONG: "$4.99/month",
  HEADLINE: "Your first design is on us.",
  SUBLINE: "Create your free Backyard Buddy account and see what your own backyard could become.",
  CTA: "Create my free design",
  PROMISE: "Dream it. See it. Find it. Build it.",
};
